import { useState, useEffect } from 'react';
import { getAllCustomFields } from 'components/FilterMenus/FilterMenus.service';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';

const useAllCustomFieldsMapper = () => {
  const pmSensor = useSelector(pmIntegrationSelector) || {};
  const sensorId = pmSensor?.sensor_id;

  const [customFieldsMapper, setCustomFieldsMapper] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchAllCustomFields = async () => {
    setIsLoading(true);
    try {
      const allCustomFields = await getAllCustomFields({ sensorId });
      const customFieldsMapper = allCustomFields.reduce((acc, field) => {
        acc[field.entity_id] = field.value;
        return acc;
      }, {});
      setCustomFieldsMapper(customFieldsMapper);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCustomFields();
  }, [sensorId]);

  return { customFieldsMapper, isLoading };
};

export default useAllCustomFieldsMapper;
